class ProductTab extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.product-tabs__header').forEach(header => {
      header.addEventListener('click', () => {
        const item = header.closest('.product-tabs__item');
        const content = item.querySelector('.product-tabs__content');
        const isActive = item.classList.contains('active');

        if (isActive) {
          item.classList.remove('active');
          content.style.maxHeight = null;
        } else {
          item.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });

    this.querySelectorAll('.product-tabs__item.active .product-tabs__content').forEach(content => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }
}

customElements.define('product-tab', ProductTab);
